<template>
  <div class="content">
    <div class="container-fluid">
      <!-- Header -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-settings-header">
            <div class="card-header trainer-card-header">
              <h4 class="card-title trainer-title">
                <i class="nc-icon nc-settings"></i>
                Configuración
              </h4>
              <p class="card-category trainer-subtitle">
                Configuración general y seguridad del sistema
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Configuración General -->
      <div class="row">
        <div class="col-lg-6">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Configuración General</h6>
            </div>
            <div class="card-body">
              <form>
                <div class="form-group">
                  <label>Zona Horaria</label>
                  <select class="form-control">
                    <option>America/Santiago (GMT-3)</option>
                    <option>America/Lima (GMT-5)</option>
                    <option>America/Bogota (GMT-5)</option>
                  </select>
                </div>
                
                <div class="form-group">
                  <label>Idioma</label>
                  <select class="form-control">
                    <option selected>Español</option>
                    <option>English</option>
                    <option>Português</option>
                  </select>
                </div>
                
                <div class="form-group">
                  <label>Moneda</label>
                  <select class="form-control">
                    <option selected>Peso Chileno (CLP)</option>
                    <option>Dólar Americano (USD)</option>
                    <option>Euro (EUR)</option>
                  </select>
                </div>
                
                <div class="form-group">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="darkMode">
                    <label class="form-check-label" for="darkMode">
                      Modo Oscuro
                    </label>
                  </div>
                </div>
                
                <div class="form-group">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="autoSave" checked>
                    <label class="form-check-label" for="autoSave">
                      Guardado Automático
                    </label>
                  </div>
                </div>
                
                <button type="submit" class="btn trainer-btn-primary">
                  <i class="nc-icon nc-check-2"></i> Guardar Configuración
                </button>
              </form>
            </div>
          </div>
        </div>
        
        <div class="col-lg-6">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Notificaciones</h6>
            </div>
            <div class="card-body">
              <div class="trainer-notification-settings">
                <div class="trainer-notification-item">
                  <div class="trainer-notification-info">
                    <h6>Recordatorios de Sesiones</h6>
                    <p>Recibe alertas antes de cada sesión programada</p>
                  </div>
                  <div class="trainer-notification-toggle">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="sessionReminders" checked>
                      <label class="form-check-label" for="sessionReminders"></label>
                    </div>
                  </div>
                </div>
                
                <div class="trainer-notification-item">
                  <div class="trainer-notification-info">
                    <h6>Mensajes de Clientes</h6>
                    <p>Notificaciones cuando recibas nuevos mensajes</p>
                  </div>
                  <div class="trainer-notification-toggle">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="clientMessages" checked>
                      <label class="form-check-label" for="clientMessages"></label>
                    </div>
                  </div>
                </div>
                
                <div class="trainer-notification-item">
                  <div class="trainer-notification-info">
                    <h6>Actualizaciones del Sistema</h6>
                    <p>Información sobre nuevas funcionalidades</p>
                  </div>
                  <div class="trainer-notification-toggle">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="systemUpdates">
                      <label class="form-check-label" for="systemUpdates"></label>
                    </div>
                  </div>
                </div>
                
                <div class="trainer-notification-item">
                  <div class="trainer-notification-info">
                    <h6>Reportes Semanales</h6>
                    <p>Resumen semanal de actividad y progreso</p>
                  </div>
                  <div class="trainer-notification-toggle">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="weeklyReports" checked>
                      <label class="form-check-label" for="weeklyReports"></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Seguridad y Privacidad -->
      <div class="row">
        <div class="col-lg-6">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Seguridad</h6>
            </div>
            <div class="card-body">
              <div class="trainer-security-section">
                <h6>Cambiar Contraseña</h6>
                <form>
                  <div class="form-group">
                    <label>Contraseña Actual</label>
                    <input type="password" class="form-control" placeholder="Contraseña actual">
                  </div>
                  <div class="form-group">
                    <label>Nueva Contraseña</label>
                    <input type="password" class="form-control" placeholder="Nueva contraseña">
                  </div>
                  <div class="form-group">
                    <label>Confirmar Nueva Contraseña</label>
                    <input type="password" class="form-control" placeholder="Confirmar contraseña">
                  </div>
                  <button type="submit" class="btn btn-outline-primary">
                    <i class="nc-icon nc-key-25"></i> Cambiar Contraseña
                  </button>
                </form>
              </div>
              
              <hr>
              
              <div class="trainer-security-section">
                <h6>Autenticación de Dos Factores</h6>
                <p class="text-muted">Añade una capa extra de seguridad a tu cuenta</p>
                <button class="btn btn-outline-success">
                  <i class="nc-icon nc-mobile"></i> Configurar 2FA
                </button>
              </div>
              
              <hr>
              
              <div class="trainer-security-section">
                <h6>Sesiones Activas</h6>
                <div class="trainer-active-sessions">
                  <div class="trainer-session-item">
                    <div class="trainer-session-info">
                      <strong>Navegador Actual</strong>
                      <br><small>Chrome en Windows • IP: 192.168.1.100</small>
                      <br><small class="text-muted">Última actividad: Ahora</small>
                    </div>
                    <span class="badge badge-success">Actual</span>
                  </div>
                  
                  <div class="trainer-session-item">
                    <div class="trainer-session-info">
                      <strong>Móvil</strong>
                      <br><small>Safari en iPhone • IP: 192.168.1.150</small>
                      <br><small class="text-muted">Última actividad: hace 2 horas</small>
                    </div>
                    <button class="btn btn-sm btn-outline-danger">Cerrar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-6">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Privacidad y Datos</h6>
            </div>
            <div class="card-body">
              <div class="trainer-privacy-section">
                <h6>Configuración de Privacidad</h6>
                <div class="form-group">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="profileVisible" checked>
                    <label class="form-check-label" for="profileVisible">
                      Perfil visible para otros trainers
                    </label>
                  </div>
                </div>
                
                <div class="form-group">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="shareProgress" checked>
                    <label class="form-check-label" for="shareProgress">
                      Compartir estadísticas de progreso
                    </label>
                  </div>
                </div>
                
                <div class="form-group">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="dataAnalytics">
                    <label class="form-check-label" for="dataAnalytics">
                      Permitir análisis de datos para mejoras
                    </label>
                  </div>
                </div>
              </div>
              
              <hr>
              
              <div class="trainer-privacy-section">
                <h6>Gestión de Datos</h6>
                <p class="text-muted">Controla tus datos personales y de clientes</p>
                <div class="trainer-data-actions">
                  <button class="btn btn-outline-info mb-2 w-100">
                    <i class="nc-icon nc-paper"></i> Descargar Mis Datos
                  </button>
                  <button class="btn btn-outline-warning mb-2 w-100">
                    <i class="nc-icon nc-settings-gear-65"></i> Exportar Configuración
                  </button>
                  <button class="btn btn-outline-danger w-100" @click="confirmDeleteAccount">
                    <i class="nc-icon nc-simple-remove"></i> Eliminar Cuenta
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Compliance y Certificaciones -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Compliance y Datos de Salud</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <div class="trainer-compliance-section">
                    <h6>Cumplimiento Normativo</h6>
                    <div class="trainer-compliance-item">
                      <div class="trainer-compliance-icon">
                        <i class="nc-icon nc-check-2 text-success"></i>
                      </div>
                      <div class="trainer-compliance-info">
                        <strong>GDPR Compliance</strong>
                        <p>Cumplimiento con regulaciones europeas de protección de datos</p>
                      </div>
                    </div>
                    
                    <div class="trainer-compliance-item">
                      <div class="trainer-compliance-icon">
                        <i class="nc-icon nc-check-2 text-success"></i>
                      </div>
                      <div class="trainer-compliance-info">
                        <strong>HIPAA Compliance</strong>
                        <p>Protección de información de salud personal</p>
                      </div>
                    </div>
                    
                    <div class="trainer-compliance-item">
                      <div class="trainer-compliance-icon">
                        <i class="nc-icon nc-check-2 text-success"></i>
                      </div>
                      <div class="trainer-compliance-info">
                        <strong>Ley de Protección de Datos</strong>
                        <p>Cumplimiento con regulaciones locales</p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="col-lg-6">
                  <div class="trainer-compliance-section">
                    <h6>Configuración de Datos de Salud</h6>
                    <div class="form-group">
                      <label>Retención de Datos de Clientes</label>
                      <select class="form-control">
                        <option>1 año después de la última sesión</option>
                        <option>2 años después de la última sesión</option>
                        <option>5 años después de la última sesión</option>
                        <option>Indefinido (con consentimiento)</option>
                      </select>
                    </div>
                    
                    <div class="form-group">
                      <label>Nivel de Encriptación</label>
                      <select class="form-control">
                        <option selected>AES-256 (Recomendado)</option>
                        <option>AES-128</option>
                      </select>
                    </div>
                    
                    <div class="form-group">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="anonymizeData" checked>
                        <label class="form-check-label" for="anonymizeData">
                          Anonimizar datos después del período de retención
                        </label>
                      </div>
                    </div>
                    
                    <div class="form-group">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="auditLog" checked>
                        <label class="form-check-label" for="auditLog">
                          Registro de auditoría de accesos a datos
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <hr>
              
              <div class="trainer-compliance-actions">
                <h6>Acciones de Compliance</h6>
                <div class="row">
                  <div class="col-md-3">
                    <button class="btn btn-outline-primary w-100 mb-2">
                      <i class="nc-icon nc-paper"></i>
                      <br>Generar Reporte de Compliance
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button class="btn btn-outline-info w-100 mb-2">
                      <i class="nc-icon nc-settings-gear-65"></i>
                      <br>Auditoría de Datos
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button class="btn btn-outline-success w-100 mb-2">
                      <i class="nc-icon nc-check-2"></i>
                      <br>Verificar Integridad
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button class="btn btn-outline-warning w-100 mb-2">
                      <i class="nc-icon nc-paper"></i>
                      <br>Exportar Logs
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Información del Sistema -->
      <div class="row">
        <div class="col-lg-6">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Información del Sistema</h6>
            </div>
            <div class="card-body">
              <div class="trainer-system-info">
                <div class="trainer-info-item">
                  <span>Versión de la Aplicación:</span>
                  <strong>v2.1.3</strong>
                </div>
                <div class="trainer-info-item">
                  <span>Última Actualización:</span>
                  <strong>15 Enero 2024</strong>
                </div>
                <div class="trainer-info-item">
                  <span>Servidor:</span>
                  <strong>trainer-app-01.centralgym.com</strong>
                </div>
                <div class="trainer-info-item">
                  <span>Estado del Sistema:</span>
                  <span class="badge badge-success">Operativo</span>
                </div>
                <div class="trainer-info-item">
                  <span>Uptime:</span>
                  <strong>99.9%</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-6">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Soporte y Ayuda</h6>
            </div>
            <div class="card-body">
              <div class="trainer-support-options">
                <button class="btn btn-outline-primary w-100 mb-3">
                  <i class="nc-icon nc-chat-33"></i>
                  Chat con Soporte
                </button>
                <button class="btn btn-outline-info w-100 mb-3">
                  <i class="nc-icon nc-paper"></i>
                  Centro de Ayuda
                </button>
                <button class="btn btn-outline-success w-100 mb-3">
                  <i class="nc-icon nc-email-85"></i>
                  Contactar por Email
                </button>
                <button class="btn btn-outline-warning w-100">
                  <i class="nc-icon nc-bulb-63"></i>
                  Sugerir Mejora
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainerSettings',
  methods: {
    confirmDeleteAccount() {
      this.$swal.fire({
        title: '¿Eliminar cuenta?',
        text: 'Esta acción es irreversible. Se eliminarán todos tus datos.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#9ACD32',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal.fire(
            'Solicitud Enviada',
            'Tu solicitud de eliminación de cuenta ha sido enviada.',
            'info'
          );
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  --trainer-primary: #9ACD32;
  --trainer-secondary: #7CB342;
  --trainer-accent: #8BC34A;
  --trainer-dark: #689F38;
  --trainer-light: #DCEDC8;
  --trainer-bg: #F1F8E9;
}

.trainer-settings-header {
  background: linear-gradient(135deg, var(--trainer-primary), var(--trainer-secondary));
  color: white;
  border: none;
  box-shadow: 0 4px 20px 0px rgba(154, 205, 50, 0.14), 0 7px 10px -5px rgba(154, 205, 50, 0.4);
  
  .trainer-card-header {
    background: transparent;
    border: none;
  }
  
  .trainer-title {
    color: white;
    font-weight: 500;
    margin-bottom: 5px;
    
    i {
      margin-right: 10px;
    }
  }
  
  .trainer-subtitle {
    color: rgba(255,255,255,0.8);
    margin: 0;
  }
}

.trainer-card {
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  margin-bottom: 20px;
  
  .card-header {
    background: var(--trainer-bg);
    border-bottom: 1px solid #dee2e6;
    
    .card-title {
      color: var(--trainer-dark);
      font-weight: 600;
      margin: 0;
    }
  }
}

.trainer-notification-settings {
  .trainer-notification-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #f0f0f0;
    
    &:last-child {
      border-bottom: none;
    }
    
    .trainer-notification-info {
      flex: 1;
      
      h6 {
        margin: 0 0 5px 0;
        color: var(--trainer-dark);
        font-weight: 600;
      }
      
      p {
        margin: 0;
        color: #666;
        font-size: 14px;
      }
    }
    
    .trainer-notification-toggle {
      .form-switch .form-check-input {
        width: 2.5em;
        height: 1.25em;
        background-color: #e9ecef;
        border: none;
        
        &:checked {
          background-color: var(--trainer-primary);
        }
      }
    }
  }
}

.trainer-security-section {
  margin-bottom: 25px;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  h6 {
    color: var(--trainer-dark);
    margin-bottom: 15px;
    font-weight: 600;
  }
}

.trainer-active-sessions {
  .trainer-session-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 6px;
    margin-bottom: 10px;
    
    .trainer-session-info {
      flex: 1;
      
      strong {
        color: var(--trainer-dark);
      }
      
      small {
        color: #666;
      }
    }
  }
}

.trainer-privacy-section {
  margin-bottom: 20px;
  
  h6 {
    color: var(--trainer-dark);
    margin-bottom: 15px;
    font-weight: 600;
  }
  
  .trainer-data-actions {
    .btn {
      text-align: left;
      
      i {
        margin-right: 8px;
      }
    }
  }
}

.trainer-compliance-section {
  h6 {
    color: var(--trainer-dark);
    margin-bottom: 20px;
    font-weight: 600;
  }
  
  .trainer-compliance-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    
    .trainer-compliance-icon {
      width: 40px;
      height: 40px;
      background: rgba(40, 167, 69, 0.1);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 15px;
      
      i {
        font-size: 20px;
      }
    }
    
    .trainer-compliance-info {
      flex: 1;
      
      strong {
        color: var(--trainer-dark);
        display: block;
        margin-bottom: 5px;
      }
      
      p {
        margin: 0;
        color: #666;
        font-size: 14px;
      }
    }
  }
}

.trainer-compliance-actions {
  margin-top: 20px;
  
  h6 {
    color: var(--trainer-dark);
    margin-bottom: 20px;
    font-weight: 600;
  }
  
  .btn {
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    
    i {
      font-size: 20px;
      margin-bottom: 5px;
    }
  }
}

.trainer-system-info {
  .trainer-info-item {
    display: flex;
    justify-content: space-between;
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f0;
    
    &:last-child {
      border-bottom: none;
    }
    
    span {
      color: #666;
    }
    
    strong {
      color: var(--trainer-dark);
    }
  }
}

.trainer-support-options {
  .btn {
    text-align: left;
    
    i {
      margin-right: 10px;
    }
  }
}

.trainer-btn-primary {
  background: var(--trainer-primary);
  border-color: var(--trainer-primary);
  color: white;
  
  &:hover {
    background: var(--trainer-secondary);
    border-color: var(--trainer-secondary);
  }
}

.form-control {
  border: 2px solid #e9ecef;
  border-radius: 6px;
  
  &:focus {
    border-color: var(--trainer-primary);
    box-shadow: 0 0 0 0.2rem rgba(154, 205, 50, 0.25);
  }
}

.form-check-label {
  color: var(--trainer-dark);
  cursor: pointer;
}

.form-check-input:checked {
  background-color: var(--trainer-primary);
  border-color: var(--trainer-primary);
}
</style>